import React from 'react'
import styled, { css } from 'styled-components'
import media from '../../utils/media'
import Text from '../../utils/Text'

const Container = styled.div`
  display: inline-block;
  margin: ${props => props.btnMarginT}px auto
    ${props => props.btnMarginB}px;
  ${media.mobileL`
    margin: calc(${props =>
      props.btnMarginT}px - 10px) auto calc(${props =>
    props.btnMarginB}px / 1.5);
  `}
`

const StyledBtn = styled.button`
  height: 50px;
  width: 262px;
  border-radius: 0;
  border-color: ${props => props.btnBg};
  background-color: ${props => props.btnBg};
  transition: background-color 0.2s ease-in;
  color: ${props => props.btnColor};
  font-size: ${props => props.btnTextSize}px !important;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0.19px;
  line-height: 21px;
  white-space: nowrap;
  vertical-align: middle;
  padding: 15px;
  border: none;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  &:hover {
    text-decoration: none !important;
  }
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  &:active {
    opacity: 0.7;
  }
  ${props =>
    props.disabled === true &&
    css`
      opacity: 40%;
      pointer-events: none;
    `}
`

export default function Btn({
  btn,
  action,
  id,
  className,
  type,
  disabled,
}) {
  const {
    btnText,
    btnTextSize,
    btnColor,
    btnBg,
    btnMarginT,
    btnMarginB,
  } = btn

  return (
    <Container
      btnMarginT={btnMarginT}
      btnMarginB={btnMarginB}
      className={`styled-btn-action ${className}`}
    >
      <StyledBtn
        onClick={action}
        id={id}
        btnColor={btnColor}
        btnBg={btnBg}
        btnTextSize={btnTextSize}
        type={type}
        disabled={disabled}
      >
        <Text id={btnText} />
      </StyledBtn>
    </Container>
  )
}
